/* Druckmomente – Storefront-Verhalten (ohne Fremdbibliotheken, Web Components) */
(() => {
  const cfg = window.dmConfig || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const eur = (cents) => (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  window.dmEur = eur;

  /* ---------- Toast (Masterplan 6.7) ---------- */
  let toastTimer;
  window.dmToast = (text) => {
    const el = $('[data-dm-toast]');
    if (!el) return;
    el.textContent = text;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2200);
  };

  /* ---------- Lieferdatum (Masterplan 6.4): heute + n Werktage, Bestellschluss, Feiertage DE + Sachsen ---------- */
  const easter = (y) => {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  };
  const holidayCache = {};
  const holidays = (y) => {
    if (holidayCache[y]) return holidayCache[y];
    const e = easter(y), add = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
    const nov23 = new Date(y, 10, 23), bussUndBettag = add(nov23, -(((nov23.getDay() + 7 - 3) % 7) || 7));
    const list = [new Date(y, 0, 1), add(e, -2), add(e, 1), new Date(y, 4, 1), add(e, 39), add(e, 50),
      new Date(y, 9, 3), new Date(y, 9, 31), bussUndBettag, new Date(y, 11, 25), new Date(y, 11, 26)];
    return (holidayCache[y] = new Set(list.map((d) => d.toDateString())));
  };
  const isWorkday = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !holidays(d.getFullYear()).has(d.toDateString());
  const nextWorkday = (d) => { const n = new Date(d); do { n.setDate(n.getDate() + 1); } while (!isWorkday(n)); return n; };
  const DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  const fmt = (d) => `${DAYS[d.getDay()]}, ${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.`;
  const computeEta = () => {
    const now = new Date(), cutoff = cfg.cutoffHour ?? 12, lead = cfg.leadDays ?? 5;
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const start = isWorkday(today) && now.getHours() < cutoff ? today : nextWorkday(today);
    let eta = new Date(start);
    for (let i = 0; i < lead; i++) eta = nextWorkday(eta);
    const cutoffLabel = start.getTime() === today.getTime() ? 'heute' : DAYS[start.getDay()];
    return { eta: fmt(eta), cutoff: `${cutoffLabel}, ${cutoff} Uhr` };
  };
  const paintEta = (root = document) => {
    const { eta, cutoff } = computeEta();
    $$('[data-dm-eta]', root).forEach((el) => { if (el.textContent !== eta) el.textContent = eta; });
    $$('[data-dm-cutoff]', root).forEach((el) => { if (el.textContent !== cutoff) el.textContent = cutoff; });
  };
  window.dmPaintEta = paintEta;

  /* ---------- Merkliste (Masterplan 6.8): localStorage['dm-wishlist'] = Handles ---------- */
  const WKEY = 'dm-wishlist';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
  const writeWish = (list) => { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} document.dispatchEvent(new CustomEvent('dm:wishlist', { detail: list })); };
  window.dmWish = { read: readWish, write: writeWish };
  const paintWish = () => {
    const list = readWish();
    $$('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', list.includes(b.dataset.wish) ? 'true' : 'false'));
    $$('[data-wish-count]').forEach((el) => { el.textContent = list.length || ''; el.dataset.count = list.length; });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    const h = b.dataset.wish, list = readWish(), on = list.includes(h);
    writeWish(on ? list.filter((x) => x !== h) : [...list, h]);
    window.dmToast(on ? cfg.strings.wishRemoved : cfg.strings.wishAdded);
  });
  document.addEventListener('dm:wishlist', paintWish);
  window.addEventListener('storage', (e) => e.key === WKEY && paintWish());

  /* ---------- Dialoge: Mobil-Menü, Bottom-Sheet (Fokusfalle + Esc) ---------- */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,summary,[tabindex]:not([tabindex="-1"])';
  let lastOpener = null;
  const openDialog = (id, opener) => {
    const el = document.getElementById(id);
    if (!el) return;
    lastOpener = opener || document.activeElement;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    opener && opener.setAttribute('aria-expanded', 'true');
    const f = $$(FOCUSABLE, el).filter((x) => x.offsetParent !== null);
    f[0] && f[0].focus();
  };
  const closeDialog = (el) => {
    el.hidden = true;
    document.body.style.overflow = '';
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    lastOpener && lastOpener.focus && lastOpener.focus();
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-dm-open]');
    if (o) { e.preventDefault(); openDialog(o.dataset.dmOpen, o); return; }
    const c = e.target.closest('[data-dm-close]');
    if (c) { const el = document.getElementById(c.dataset.dmClose); el && closeDialog(el); }
  });
  document.addEventListener('keydown', (e) => {
    const open = $$('.dm-drawer-nav:not([hidden]), .dm-sheet:not([hidden])').pop();
    if (!open) return;
    if (e.key === 'Escape') return closeDialog(open);
    if (e.key === 'Tab') {
      const f = $$(FOCUSABLE, open).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- Mega-Menü (Masterplan 6.2): Klick, Esc, Klick außerhalb ---------- */
  const megaBtn = $('[data-dm-mega]'), mega = $('#DmMega');
  if (megaBtn && mega) {
    const setMega = (on) => { mega.hidden = !on; megaBtn.setAttribute('aria-expanded', on ? 'true' : 'false'); if (on) { const a = $('a', mega); a && a.focus(); } };
    megaBtn.addEventListener('click', () => setMega(mega.hidden));
    document.addEventListener('click', (e) => { if (!mega.hidden && !mega.contains(e.target) && !megaBtn.contains(e.target)) setMega(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !mega.hidden) { setMega(false); megaBtn.focus(); } });
  }

  /* ---------- Tabs ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-dm-tab]');
    if (!t) return;
    const root = t.closest('[data-dm-tabs]');
    $$('[data-dm-tab]', root).forEach((x) => x.setAttribute('aria-selected', x === t ? 'true' : 'false'));
    $$('[data-dm-panel]', root).forEach((p) => (p.hidden = p.id !== t.getAttribute('aria-controls')));
  });

  // Helfer für die seitenbezogenen Skripte (dm-collection.js, dm-wishlist.js)
  window.dm = { $, $$, eur, cfg, readWish, writeWish, paintWish, closeDialog, paintEta };
  /* ---------- Start ---------- */
  const boot = () => { paintEta(); paintWish(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  // Warenkorb-Schublade wird nach dem Hinzufügen neu gerendert → Datum neu setzen
  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) new MutationObserver(() => { paintEta(drawerEl); }).observe(drawerEl, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', boot);
})();

/* Schnell-Hinzufügen (Upsell in Schublade/Warenkorb) ohne Seitenwechsel */
document.addEventListener('submit', async (e) => {
  const f = e.target.closest('form[data-dm-quickadd]');
  if (!f) return;
  e.preventDefault();
  const drawer = document.querySelector('cart-drawer');
  const id = parseInt(new FormData(f).get('id'), 10);
  const res = await fetch(`${window.routes.cart_add_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }) });
  const data = await res.json();
  if (!res.ok) { window.dmToast && window.dmToast(data.description || 'Konnte nicht hinzugefügt werden'); return; }
  window.dmToast && window.dmToast((window.dmConfig?.strings?.cartAdded) || 'In den Warenkorb gelegt');
  if (drawer && data.sections && !location.pathname.startsWith('/cart')) drawer.renderContents({ ...data, id });
  else location.reload();
});


/* Clarity-Ereignisse (26.10.): nur wenn Clarity läuft. Vor dem Laden gemerkt, dm-clarity reicht sie nach (keine Wirkung auf Einwilligung/Laden). */
window.dmEv = (n, k, v) => { const a = k ? ['set', k, v] : ['event', n]; window.clarity ? window.clarity(...a) : (window.dmEvQ ||= []).push(a); };
addEventListener('click', (e) => { const t = e.target.closest('[data-cev]'); if (t) window.dmEv(t.dataset.cev); }, true);
if (/^\/products\/musterset/.test(location.pathname)) window.dmEv('musterset_geoeffnet');
